import { InputProps } from '@mui/material';
import { isEmpty, isNotEmpty } from 'ramda';
import { useMemo, useState } from 'react';

export interface UseChatInputMessageProps {
  handleSubmit: () => void;
}

export interface UseChatInputMessageReturn extends Pick<InputProps, 'onKeyDown' | 'onChange' | 'value'> {
  message: string;
  hasMessage: boolean;
  clearMessage: () => void;
}

export const useChatInputMessage = ({ handleSubmit }: UseChatInputMessageProps): UseChatInputMessageReturn => {
  const [value, setValue] = useState('');

  return useMemo(
    () => ({
      onKeyDown: (event) => {
        if (event.key === 'Enter' && !event.shiftKey && !event.metaKey) {
          if (isEmpty(value.trim())) {
            return;
          }
          handleSubmit();
          // Prevent default to avoid adding a new line after sending the content
          event.preventDefault();
        }
      },
      onChange: (event) => setValue(event.target.value),
      value,
      message: value.trim(),
      hasMessage: isNotEmpty(value.trim()),
      clearMessage: () => setValue(''),
    }),
    [handleSubmit, value],
  );
};
